<template>
    <section id="sme-form" class="sme-form">
        <div class="sme-form__container" :class="{'sme-form__construction_bg': construction === 'Y'}">
            <preloader v-show="loading"></preloader>
            <sme-form-message
                v-if="isSended"
                title="Ваша заявка успешно отправлена"
                subtitle="Наш оператор свяжется с вами в ближайшее время и проконсультирует по вопросам"
            />
            <sme-form-message
                v-if="isDouble"
                title="Вы уже отправляли заявку"
                subtitle="Пожалуйста, дождитесь звонка менеджера"
                type="double"
            />
            <sme-form-message
                v-if="isError"
                title="Не смогли отправить вашу заявку"
                subtitle="По техническим причинам мы не смогли отправить вашу заявку. Повторите попытку позже"
                type="error"
            />
            <div v-if="!isSended && !isDouble && !isError" class="sme-form__vcontent" :style="{ backgroundImage: !!bgImage ? `url(${bgImage})` : undefined, }">
                <div class="h2 _w-592" v-html="setTitle"></div>
                <p class="sme-form__subtitle p1 _mt-16-8" v-if="setSubtitle" v-html="setSubtitle"></p>
                <form class="sme-form__vform _mt-32" ref="form" onsubmit="return false;">
                    <div class="form__group">
                        <div class="form__row">
                            <div class="form__col">
                                <div class="form__item form__item-wide">
                                    <vue-suggestion
                                        name="surname"
                                        id="lastName"
                                        data-model-path="lastName"
                                        v-model="$v.lastName.$model"
                                        label="Фамилия"
                                        :class="{'_invalid': $v.lastName.$error, '_focus': lastName.length > 0}"
                                        method="fio"
                                        :parts="['SURNAME']"
                                    >
                                    </vue-suggestion>
                                    <p class="form-error" v-if="!$v.lastName.required && $v.lastName.$anyDirty">Поле обязательное для заполнения.</p>
                                    <p class="form-error" v-if="!$v.lastName.cyrWithDash && $v.lastName.$anyDirty">Поле не&nbsp;должно содержать цифры, спецсимволы и латинские буквы</p>
                                </div>
                            </div>
                            <div class="form__col">
                                <div class="form__item form__item-wide">
                                    <vue-suggestion
                                        name="name"
                                        id="firstName"
                                        data-model-path="firstName"
                                        v-model="$v.firstName.$model"
                                        label="Имя"
                                        :class="{'_invalid': $v.firstName.$error, '_focus': firstName.length > 0}"
                                        method="fio"
                                        :parts="['NAME']"
                                    >
                                    </vue-suggestion>
                                    <p class="form-error" v-if="!$v.firstName.required && $v.firstName.$anyDirty">Поле обязательное для заполнения.</p>
                                    <p class="form-error" v-if="!$v.firstName.cyrWithDash && $v.firstName.$anyDirty">Поле не&nbsp;должно содержать цифры, спецсимволы и латинские буквы</p>
                                </div>
                            </div>
                        </div>
                        <div class="form__row">
                            <div class="form__col">
                                <div class="form__item form__item-wide">
                                    <div class="form__input">
                                        <input
                                            type="text"
                                            id="phone_number"
                                            v-model="phone"
                                            v-phone
                                            class="d-input form__input_nolbl _focus-always"
                                            :class="{'_invalid': $v.phone.$error || phoneStartsAtEight, '_focus': phone.length > 0}"
                                            v-mask="'+7 ### ### ## ##'"
                                            name="phone"
                                            placeholder="Телефон"
                                        >
                                        <p class="form-error" v-if="!$v.phone.required && $v.phone.$anyDirty">Поле обязательное для заполнения.</p>
                                        <p class="form-error" v-if="!$v.phone.minLength && $v.phone.$anyDirty">Поле должно содержать не менее 11 символов.</p>
                                        <p class="form-error" v-if="$v.phone.$error && $v.phone.required && !$v.phone.seemsDigitInPhone">Проверьте корректность номера.</p>
                                        <p class="form-error" v-if="phoneStartsAtEight">Вводите номер телефона с цифры 9</p>
                                        <p class="form-error" v-if="$v.phone.$error && !$v.phone.uniqPhone">Не должен совпадать с другими номерами телефонов.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="form__col">
                                <div class="form__item form__item-wide">
                                    <vue-suggestion
                                        name="email"
                                        v-model="email"
                                        label="Email"
                                        :class="{'_invalid': $v.email.$error, '_focus': email.length > 0}"
                                        method="email"
                                    >
                                    </vue-suggestion>
                                    <p class="form-error" v-if="!$v.email.required && $v.email.$anyDirty">Поле обязательное для заполнения.</p>
                                    <p class="form-error" v-if="!$v.email.email && $v.email.$anyDirty">Введите корректный Email</p>
                                </div>
                            </div>
                        </div>

                        <div class="form__row" v-if="!construction && !acquiring">
                            <div class="form__item form__item-wide">
                                <vue-suggestion
                                    :class="{ '_invalid': $v.companyName.$error || nameOrInnError, '_focus': companyName.length, '_open': isSuggestionOpen }"
                                    name="company_name"
                                    v-model="companyName"
                                    label="Название организации или ИНН"
                                    method="party"
                                    @selectNothing="nameOrInnSuggestionOptions.onSelectNothing"
                                    @select="nameOrInnSuggestionOptions.onSelect"
                                ></vue-suggestion>
                                <transition name="fade">
                                    <p
                                        class="form-error"
                                        v-if="$v.companyName.$error || nameOrInnError"
                                    >
                                        <template v-if="!$v.companyName.required">
                                            Это поле необходимо заполнить.
                                        </template>
                                        <template v-else>
                                            Процедура не&nbsp;может быть завершена. Просьба обратиться в&nbsp;Банк
                                        </template>
                                    </p>
                                </transition>
                            </div>
                        </div>

                        <div class="form__row">
                            <div class="form__item form__item-wide">
                                <vue-suggestion
                                    :class="{ '_invalid': $v.companyInn.$error || nameOrInnError, '_focus': companyInn.length, '_open': isSuggestionOpen }"
                                    name="company_inn"
                                    v-model="companyInn"
                                    :label="companyInnLabel"
                                    method="party"
                                    @selectNothing="nameOrInnSuggestionOptions.onSelectNothing"
                                    @select="nameOrInnSuggestionOptions.onSelect"
                                ></vue-suggestion>
                                <transition name="fade">
                                    <p
                                        class="form-error"
                                        v-if="$v.companyInn.$error || nameOrInnError"
                                    >
                                        <template v-if="!$v.companyInn.required">
                                            Это поле необходимо заполнить.
                                        </template>
                                        <template v-else>
                                            Процедура не&nbsp;может быть завершена. Просьба обратиться в&nbsp;Банк
                                        </template>
                                    </p>
                                </transition>
                            </div>
                        </div>

                        <div class="form__row" v-if="agentCode">
                            <div class="form__item form__item-wide">
                                <vue-suggestion
                                    id="registrationAddress"
                                    v-model="houseAddress"
                                    label="Адрес дома, для которого будет открыт счёт"
                                    :class="{'_invalid': $v.houseAddress.$error, '_focus': houseAddress.length > 0}"
                                    method="address"
                                >
                                </vue-suggestion>
                                <p class="form-error" v-if="$v.houseAddress.$error && !$v.houseAddress.required">Поле обязательное для заполнения.</p>
                            </div>
                        </div>

                        <div class="form__row">
                            <div class="form__item form__item-wide">
                                <d-select
                                    v-model="$v.cityId.$model"
                                    :items="cities"
                                    label="Город"
                                    :invalid="$v.cityId.$error && $v.$dirty"
                                    :error="$v.cityId.$error && $v.$dirty ? 'Это поле необходимо заполнить.' : ''"
                                />
                            </div>
                        </div>
                        <div class="form__row">
                            <div class="form__item form__item-wide">
                                <d-select
                                    v-model="$v.officeId.$model"
                                    :items="offices"
                                    label="Офис банка"
                                    :disabled="!city"
                                    :invalid="$v.officeId.$error && $v.$dirty"
                                    :error="$v.officeId.$error && $v.$dirty ? 'Это поле необходимо заполнить.' : ''"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="form__item">
                        <div class="checkbox">
                            <input
                                v-model="$v.agreement.$model"
                                type="checkbox"
                                :class="{ '_invalid': $v.agreement.$error }"
                                class="checkbox__input"
                                id="sme-form-terms"
                                name="agreement"
                            >
                            <label for="sme-form-terms" class="checkbox__label">
                                <span class="p1">
                                    Я соглашаюсь с <a class="link" target="_blank" :href="privacyPolicyConditions">
                                    условиями обработки и использования персональных данных</a>
                                    и подтверждаю согласие на использование
                                    <a :href="simpleElectronicSignature" target="_blank" class="link">
                                    простой электронной подписи</a>
                                </span>
                            </label>
                        </div>
                    </div>
                    <div class="_mt-32">
                        <div class="form__item">
                            <button type="submit" class="sme-form__submit button button_green" @click="onSubmit" v-html="buttonName"></button>
                        </div>
                        <div class="_dflex form__item _mt-24full">
                            <div><img class="_mr-24 ico_size_24" src="/local/templates/redesign/src/assets/img/sme/credits/safety24.png" /></div>
                            <p class="gray-text-light text-small">Мы защищаем ваши персональные данные, не раскрываем их третьим лицам и не распространяем без вашего согласия на это, если иное не предусмотрено законодательством </p>
                        </div>
                    </div>
                </form>
            </div>
        </div>

        <modal-with-yandex-captcha
            :requested="modalSmsShow"
            :phone="phone"
            :endpoint="endpoint"
            @closeCaptchaSms="modalSmsShow = false"
            @smsConfirmed="sendForm"
        />

    </section>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email, minLength } from 'vuelidate/lib/validators'
import { cyrWithDash } from '../../assets/js/vue/validations'
import axios from 'axios'
import { getQueryParameterByName, getSessid, getCitiesV2, getOfficesV2, scrollToElem } from '../../assets/js/utils'
import SmeFormMessage from '../../components-manual/sme/SmeFormMessage.vue';

export default {
    components: {
        SmeFormMessage
    },
    name: 'SmeForm',
    mixins: [
        validationMixin,
    ],
    props: {
        buttonNameIn: {
            type: String,
            default: 'Оставить заявку',
        },
        title: {
            type: String,
            default: '',
        },
        subtitle: {
            type: String,
            default: '',
        },
        action: {
            type: String,
            default: '',
        },
        privacyPolicy: {
            type: String,
            default: '/upload/docs/sme/soglasie_na_obrabotku_personalnyh_dannyh.pdf'
        },
        privacyPolicyCredit: {
            type: String,
            default: '/upload/docs/sme/credits/soglasie_na_obrabotku_personalnyh_dannyh.pdf'
        },
        privacyPolicyConstruction: {
            type: String,
            default: '/upload/docs/sme/construction/soglasie_na_obrabotku_personalnyh_dannyh.docx'
        },
        simpleElectronicSignature: {
            type: String,
            default: '/upload/docs/sme/soglashenie_ob_ispolzovanii_pep.pdf'
        },
        product: {
            type: String,
            default: 'Продукт малого бизнеса'
        },
        productName: {
            type: String,
            default: "",
        },
        productSecondName: {
            type: String,
            default: "",
        },
        productNameAdditional: {
            type: String,
            default: "",
        },
        leadType: {
            type: String,
            default: "Заявка на продукт"
        },
        bgImage: {
            type: String,
            default: '/local/templates/redesign/src/assets/img/sme/form.webp',
        },
        imgSent: {
            type: String,
            default: '',
        },
        construction: {
            type: String,
            default: "",
        },
        acquiring: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            firstName: '',
            lastName: '',
            phone: '',
            email: '',
            companyName: '',
            companyInn: '',
            inn: '',
            cityId: '',
            officeId: '',
            agentCode: '',
            houseAddress: '',
            sessid: window.config.bitrix_sessid,
            agreement: false,
            isSuggestionOpen: false,
            isSended: false,
            isDouble: false,
            isError: false,
            phoneStartsAtEight: false,
            cities: [],
            offices: [],
            nameOrInnSuggestionOptions: {
                onSelectNothing: () => {
                    this.companyName = '';
                    this.companyInn = '';
                    this.isSuggestionOpen = false;
                },
                onSelect: this.onSuggestionSelect,
            },
            nameOrInnError: false,
            loading: false,
            productAdditional: '',
            tryToSend: false,
            modalSmsShow: false,
            currentUrl: '',
            endpoint: '',
        };
    },
    validations() {
        return {
            firstName: {
                cyrWithDash,
                required,
            },
            lastName: {
                cyrWithDash,
                required,
            },
            phone: {
                minLength: minLength(16),
                required,
            },
            email: {
                email,
                required,
            },
            companyName: {
                required,
            },
            companyInn: {
                required,
            },
            cityId: {
                required,
            },
            officeId: {
                required,
            },
            houseAddress: {
                required: this.agentCode ? required : () => {return true},
            },
            agreement: {
                required: val => val
            },
        }
    },
    computed: {
        privacyPolicyConditions() {
            if (this.currentUrl === '/sme/credits/') return this.privacyPolicyCredit;
            if (this.currentUrl === '/sme/construction/') return this.privacyPolicyConstruction;
            return this.privacyPolicy;
        },
        setTitle() {
            return this.title === '' ? 'Оставить заявку' : this.title;
        },
        setSubtitle() {
            return this.subtitle === '' ? 'Оставьте заявку и наш оператор свяжется с вами' : this.subtitle === ' ' ? '' : this.subtitle;
        },
        buttonName() {
            if (!this.buttonNameIn.length) {
                return "Оставить заявку";
            }
            return this.buttonNameIn;
        },
        notice() {
            if (document.querySelectorAll('.sme-deposits__form').length) {
                return true;
            }
            return false;
        },
        city() {
            return this.cities.find(city => {
                return city.const === this.cityId;
            });
        },
        office() {
            return this.offices.find(office => {
                return office.const === this.officeId;
            });
        },
        officesByCity() {
            return this.offices.filter(office => {
                return office.city_id === this.cityId;
            });
        },
        isBankiru() {
            return getQueryParameterByName('transaction_id') !== '' && getQueryParameterByName('utm_campaign') === 'per_express_credit_banki' && getQueryParameterByName('utm_source') === 'banki';
        },
        companyInnLabel() {
            return this.construction ? 'Названии организации или ИНН' : this.acquiring ? 'ИНН организации' : 'ИНН владельца счета'
        },
    },
    methods: {
        onSubmit() {
            this.$v.$touch();

            if (!this.$v.$invalid) {
                this.modalSmsShow = true;
            }
        },
        collectUniversalFormData() {
            let data = {
                data: {
                    type: "smeAccountRepairAgentForm",
                    attributes: {
                        agreement: this.agreement,
                        name: this.firstName,
                        surname: this.lastName,
                        phone: this.phone,
                        email: this.email,
                        city: this.city.title,
                        office: this.office?.title,
                        inn: this.companyInn,
                        companyName: this.companyName,
                        agentCode: this.agentCode,
                        houseAddress: this.houseAddress
                    }
                }
            }
            return data;
        },
        sendForm() {
            this.loading = true;
            let data;

            if (this.agentCode) {
                data = this.collectUniversalFormData();
                this.loading = true;
                return axios.post('/rest/v1/universal-form?sessid=' + this.sessid, data)
                    .then(() => {
                        this.isSended = true;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }

            if (this.$props.construction === 'Y') {
                const data = {
                    data: {
                        type: "smeConstructionForm",
                        attributes: {
                            agreement: true,
                            name: this.firstName,
                            surname: this.lastName,
                            email: this.email,
                            product: 'Стройка для своих',
                            inn: this.companyInn,
                            company_name: this.companyName,
                            city: this.cityId,
                            office: this.officeId,
                            phone: this.phone.replace(/\D/g, ''),
                            lead_type: 'Заявка на продукт'
                        }
                    }
                }

               axios.post(`${this.action}?sessid=${this.sessid}`, data)
                    .then((res) => {
                        if (res.status === 201) {
                            this.isSended = true;
                            this.setPixels();
                            window.dmpkitdl.push({event: 'sme-lead-fos-send'});
                        } else {
                            if (res.status === 419) {
                                getSessid()
                                    .then(res => {
                                        this.sessid = res.data;
                                        this.onSubmit();
                                    })
                            }
                            else {
                                this.isError = true;
                            }
                        }
                    })
                    .catch((err) => {
                        if (err.response.status === 403) {
                            this.modalSmsShow = true;
                        }
                        else if (err.response.status === 429) {
                            this.$modal.show('tooManyRequests');
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
            else {
                this.checkAdditionalProduct();

                data = {
                    data: {
                        type: "smeForm",
                        attributes: {
                            name: this.firstName,
                            surname: this.lastName,
                            phone: this.phone.replace(/\D/g, ''),
                            email: this.email,
                            companyName: this.companyName,
                            agreement: this.agreement,
                            fio: [this.lastName, this.firstName].join(' '),
                            inn: this.companyInn,
                            city: this.city.title,
                            office: this.office.title,
                            leadType: 'Заявка на продукт',
                            product: this.productAdditional || 'Кредит для бизнеса',
                            additionalProductName: this.productSecondName || ''
                        }
                    }
                }
                axios.post(this.action + '?sessid=' + this.sessid, data, {headers: {'Accept': 'application/vnd.api+json', 'Content-Type': 'application/vnd.api+json'}})
                    .then(res => {
                        if (res.status === 201) {
                            this.isSended = true;
                            this.setPixels();
                            window.dmpkitdl.push({event: 'sme-lead-fos-send'});
                        } else {
                            if (res.status === 419) {
                                getSessid()
                                    .then(res => {
                                        this.sessid = res.data.data;
                                        this.onSubmit();
                                    })
                            } else {
                                this.isError = true;
                            }
                        }
                    })
                    .catch(err => {
                        if (err.response.status === 422) {
                            this.isError = true;
                        }
                        else if (err.response.status === 429) {
                            this.$modal.show('tooManyRequests');
                        }
                    })
                    .finally(() => {
                        this.loading = false;
                        scrollToElem('sme-form');
                    });
            }
        },
        onSuggestionSelect(suggestion) {
            function isValidSuggestion(item) {
                const finOrgOkved = ['64', '65', '66'];
                const isStateEstable = item.data.ogrn[0] === 2;
                const isFinOrg = item.data.okved &&  (finOrgOkved.indexOf(item.data.okved.slice(0,2)) !== -1 );
                const isLawyer = !item.data.ogrn && item.data.type === "INDIVIDUAL";

                return !isStateEstable && !isFinOrg && !isLawyer;
            }

            if (isValidSuggestion(suggestion)) {
                this.nameOrInnError = false;
                setTimeout(() => {
                    this.companyName = suggestion.data.name.short_with_opf;
                    this.companyInn = suggestion.data.inn
                }, 100);
                this.isSuggestionOpen = false;
            } else {
                this.nameOrInnError = true;
            }
        },
        initAnchor() {
            if ( getQueryParameterByName('form') == 'true') {
                this.$nextTick(() => {
                    document.getElementById('smeAnchor').click();
                });
            }
        },
        setPixels() {
            if (this.isBankiru) {
                let pixel = document.createElement('img');
                pixel.src = 'https://tracking.banki.ru/SP239?adv_sub=' + this.sessid + '&transaction_id=' + getQueryParameterByName('transaction_id');
                document.head.appendChild(pixel);
            }
        },
        clearForm() {
            this.firstName = '';
            this.lastName = '';
            this.phone = '';
            this.email = '';
            this.companyName = '';
            this.companyInn = '';
            this.cityId = '';
            this.officeId = '';
            this.agentCode = '';
            this.houseAddress = '';
            this.agreement = false;
            this.$v.$reset();
        },
        checkAdditionalProduct() {
            if (this.$props.productNameAdditional === '' && sessionStorage.getItem('sme_additional_product') !== null && this.currentUrl === '/sme/credits/') {
                this.productAdditional = sessionStorage.getItem('sme_additional_product');
            } else if (this.currentUrl === '/sme/rko/special/' || this.currentUrl === '/sme/credits/') {
                if (sessionStorage.getItem('sme_additional_product') !== null) {
                    this.productAdditional = sessionStorage.getItem('sme_additional_product');
                } else {
                    this.productAdditional = this.$props.productNameAdditional;
                }
            } else {
                this.productAdditional = this.$props.productNameAdditional;
            }
        }
    },
    watch: {
        currentTime(time) {
            if (time === 0) {
                this.stopTimer()
            }
        },
        code(val, oldVal) {
            if (val !== oldVal) {
                this.isPhoneError = false;
            }
        },
        cityId(val) {
            getOfficesV2(val, {'isSme': 'y'})
                .then(res => {
                    res = res.data.data;

                    this.offices = res.sort((a, b) => {
                        if (a.attributes.name.main.toLowerCase() > b.attributes.name.main.toLowerCase()) {
                            return 1;
                        }
                        if (a.attributes.name.main.toLowerCase() < b.attributes.name.main.toLowerCase()) {
                            return -1;
                        }
                        return 0;
                    });

                    this.offices = this.offices.map(office => {
                        return {const: office.id, title: office.attributes.name.short};
                    });

                    this.officeId = this.offices[0].const;
                })
        }
    },
    created() {
        this.currentUrl = window.location.pathname;
        getCitiesV2()
            .then(res => {
                this.cities = res.data.data.map(item => {
                    return {
                        const: item.id,
                        title: item.attributes.name,
                    }
                });
                this.cityId = this.cities[0].const;
            })
    },
    mounted() {
        this.initAnchor();
        sessionStorage.removeItem('sme_additional_product');
        this.agentCode = getQueryParameterByName('agent');
        this.endpoint = this.agentCode ? 'smeAccountRepairAgentForm' : 'smeForm';
        if (this.$props.construction)  this.endpoint = 'smeConstructionForm';
    }
}
</script>


<style lang="scss">
@import '../../assets/scss/base/_variables.scss';
@import '../../assets/scss/base/_mixins.scss';
@import '../../assets/scss/base/_functions.scss';

$b: '.c-form';

#{$b} {
    @include fluid('padding-top', 40px, 20px);
    @include fluid('padding-bottom', 40px, 20px);

    &__form {
        display: flex;
        flex-direction: column;
        height: 100%;
        width: cols(4, 'fluid');
        color: $white-101;

        @include wide-screen {
            width: cols(4);
        }

        @include mobile {
            width: 100%;
        }

        .form__group {
            @include fluid('margin-bottom', $ind5, 20px);
        }
    }

    &__submit {
        @include fluid('margin-top', 16px, 8px);
    }

    &__input {
        @include fluid('width', 280px);

        &_br-16 {
            @include fluid('border-radius', 16px);
        }
    }
}

.form__item {
    @include mobile	{
        width: 95%;
    }
}

.sme-form {
    @include fluid('margin-bottom', $ind5, $ind3);

    &__content {
        @include fluid('padding-top', $ind7, $ind-alt3);
        @include fluid('padding-bottom', $ind7, $ind-alt3);
        @include fluid('border-radius', $ind7, 28px);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: right bottom;
        background-color: $grey-106;

        @include not-mobile {
            background-image: url("/local/templates/redesign/src/assets/img/sme/form-bg.png");
        }

        @include mobile {
            background-image: none !important;
            @include fluid('padding-right', $ind3);
            @include fluid('padding-left', $ind3);
        }

        &.sme-form_sent {
            background-image: none !important;
        }
    }

    &__vcontent {
        @include fluid('padding-top', 56px, 24px);
        @include fluid('padding-right', 56px, 16px);
        @include fluid('padding-bottom', 56px, 24px);
        @include fluid('padding-left', 56px, 16px);
        @include fluid('border-radius', 56px, 24px);
        background-color: $grey-106;
        background-image: url("/local/templates/redesign/src/assets/img/sme/form.webp");

        background-repeat: no-repeat;
        background-size: 38%;
        background-position: 100% 80%;

        @include mobile {
            background-image: none !important;
        }

        &_tourism {
            background-image: url("/local/templates/redesign/src/assets/img/corporate/tourism-form.webp");
            background-size: 45%;

            @include mobile {
                background-image: none;
            }
        }
    }

    &__vform {
        @include fluid('width', 592px);

        @include mobile {
            width: 100%;
        }
    }

    .form__group {
        @include fluid('margin-bottom', $ind3, $ind-alt3);

        @include not-mobile {
            margin-top: 0;
        }

        @include mobile {
            &:not(:first-child) {
                margin-top: 0;
            }
        }
    }

    &_sent {
        &-content {
            @include fluid('height', 340px, 250px);
            display: flex;
            flex-direction: column;

            .p1 {
                @include fluid('margin-top', $ind3, $ind1);
            }

            .p2 {
                @include fluid('margin-top', $ind3, $ind2);
            }

            .button {
                width: fit-content;
                margin-top: auto;
            }
        }

        @include mobile {
            background-color: $bg-deposits-form;

            .p1, .h2 {
                color: $white-101;
            }
        }
    }

    .form__input_nolbl {
        padding-top: 0px!important;
    }

    .form__input_nolbl::placeholder {
        color: $grey-284;
    }
}
</style>
